import { getGlobalEventsLogs } from '@cian/events-log';
import { TOPIC_USER } from '../../constants/eventsLogTopics';
import { IOpenAuthModalParameters } from '../../types/microfrontends';

export const authByEventsLogEvent = (parameters?: IOpenAuthModalParameters) => {
  getGlobalEventsLogs().produce<Required<IOpenAuthModalParameters>>(TOPIC_USER, {
    type: 'authenticate',
    value: (parameters ?? {}) as Required<IOpenAuthModalParameters>,
  });
};
